import { App } from 'vue'
import LetsDialSocketClient from '@letsdial/socket'

export let letsDialSocket: LetsDialSocketClient | undefined

export default {
  install: (app: App, options?: any) => {
    letsDialSocket = new LetsDialSocketClient(
      options?.letsDialServerUrl ?? '',
      options?.apiToken,
    )
    app.config.globalProperties.$socket = letsDialSocket

    app.provide('socket', letsDialSocket)
  },
}
